import { apiClient } from './axios';
import { PaginationData } from '../models/paginationData';
import type {
    WordReportItem,
    ReportSummary,
    ReportFilterParams,
    UpdateReportStatusRequest,
} from '../types/report';

export const reportApi = {
    getReports: async (params: ReportFilterParams) => {
        return apiClient.get<PaginationData<WordReportItem>>('/admin/reports', {
            page: params.page - 1,
            size: params.size,
            ...(params.status ? { status: params.status } : {}),
            ...(params.reportType ? { reportType: params.reportType } : {}),
        });
    },

    getSummary: async () => {
        return apiClient.get<ReportSummary>('/admin/reports/summary');
    },

    updateStatus: async (reportId: number, data: UpdateReportStatusRequest) => {
        return apiClient.patchNoData(`/admin/reports/${reportId}/status`, data);
    },
};
